const UploadFilesToS3_mutate = `
  mutation UploadFilesToS3($files: [Upload!]!, $fileName: String!, $fileUuid: String!) {
    uploadFilesToS3(files: $files, fileName: $fileName, fileUuid: $fileUuid) {
      urls
    }
  }
`;

const SetFilesAiAttributes_mutate = `
  mutation SetFilesAiAttributes($s3Urls: [String!]!) {
    setFilesAiAttributes(s3Urls: $s3Urls) {
      attributes
    }
  }
`;

const CheckAiPassword_query = `
  query CheckAiPassword($password: String!) {
    checkAiPassword(password: $password)
  }
`;

const CancelAiAttributes_mutate = `
  mutation StopAiAttributes {
    stopAiAttributes{
      status
    }
  }
`;

const UploadImagesAndSaveData_mutate = `
  mutation UploadImagesAndSaveData(
    $imagesData: [ImageUploadInput!]!,
    $email: String!,
    $title: String!,
    $description: String!,
    $category: String!,
    $subCategory: String,
    $material: String,
    $brand: String!,
    $conditions: String,
    $warnings: String,
    $sellingPrice: String!,
    $originalPrice: String,
    $dimensions: String,
    $weight: String,
    $noPlayers: String,
    $gameDuration: String,
    $color: String,
    $subColor: String,
    $ageGroup: String,
    $difficulty: String,
    $manufacturerCountry: String,
    $batteryRequired: Boolean!,
    $batteryIncluded: Boolean!,
    $assemblyRequired: Boolean!,
    $isPublished: Boolean,
    $tags: [String]
  ) {
    uploadImagesAndSaveData(
      imagesData: $imagesData,
      email: $email,
      title: $title,
      description: $description,
      category: $category,
      subCategory: $subCategory,
      material: $material,
      brand: $brand,
      conditions: $conditions,
      warnings: $warnings,
      sellingPrice: $sellingPrice,
      originalPrice: $originalPrice,
      dimensions: $dimensions,
      weight: $weight,
      noPlayers: $noPlayers,
      gameDuration: $gameDuration,
      color: $color,
      subColor: $subColor,
      ageGroup: $ageGroup,
      difficulty: $difficulty,
      manufacturerCountry: $manufacturerCountry,
      batteryRequired: $batteryRequired,
      batteryIncluded: $batteryIncluded,
      assemblyRequired: $assemblyRequired,
      isPublished: $isPublished,
      tags: $tags
    ) {
      success
    }
  }
`;

const GetToyAttrinutes_query = `
  query{
    categories{
      title
    }
    subcategories{
      title
      category{
        title
      }
    }
    brands{
      title
    }
    warnings{
      title
    }
    ageGroups{
      title
    }
    materials{
      title
    }
    colors{
      title
    }
    subColors{
      title
    }
    difficulties{
      title
    }
  	conditions{
      title
    }
    manufacturerCountries{
      name
    }
  }
`;

const DeleteS3Files_mutate = `
  mutation DeleteS3Files($s3Urls: [String!]!) {
    deleteS3Files(s3Urls: $s3Urls) {
      success
    }
  }
`;

module.exports = {
  UPLOAD_FILES_S3_MUTATION: UploadFilesToS3_mutate,
  SET_FILES_AI_ATTRIBUTES_MUTATION: SetFilesAiAttributes_mutate,
  CHECK_AI_PASSWORD_QUERY: CheckAiPassword_query,
  CANCEL_AI_ATTRIBUTES_MUTATION: CancelAiAttributes_mutate,
  UPLOAD_IMAGES_AND_SAVE_DATA_MUTATION: UploadImagesAndSaveData_mutate,
  GET_TOY_ATTRIBUTES_QUERY: GetToyAttrinutes_query,
  DELETE_S3_FILES_MUTATION: DeleteS3Files_mutate,
};
